import React, { useEffect, useRef, useState } from "react";

function ContentCard({ img, title, desc }) {
  return (
    <div className="group relative grid min-h-[20rem] sm:min-h-[26rem] items-end overflow-hidden rounded-xl mx-2 sm:mx-3">
      <img
        src={img}
        alt={title}
        className="absolute inset-0 h-full w-full object-cover object-center 
                   transition-transform duration-700 ease-out 
                   group-hover:scale-105"
      />

      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/10" />

      <div
        className="relative z-10 w-full p-4 sm:p-6 
                   transition-all duration-500 ease-out 
                   group-hover:pb-10"
      >
        <h4
          className="text-base sm:text-xl font-semibold text-white 
                     transition-all duration-500 ease-out 
                     group-hover:mb-3 group-hover:-translate-y-2"
        >
          {title}
        </h4>

        <div
          className="max-h-0 overflow-hidden 
                     transition-[max-height] duration-700 ease-in-out 
                     group-hover:max-h-48"
        >
          <p className="text-xs sm:text-sm font-normal text-gray-200 leading-relaxed">
            {desc}
          </p>
        </div>
      </div>
    </div>
  );
}

const contents = [
{
  img: "/b.jpg",
  title: "Best Budget Laptops",
  desc: "Looking for a laptop at the right price? PC Care offers a wide range of laptops that are perfect for daily use, office work, and online tasks without spending too much.",
},
{
  img: "/b1.avif",
  title: "Smart Choice for Students",
  desc: "Students can find laptops that are perfect for classes, projects, and online learning. PC Care helps you choose the right laptop based on your needs and budget.",
},
{
  img: "/b2.jpg",
  title: "Work Faster with the Right Laptop",
  desc: "A good laptop makes your work easier and faster. At PC Care, you can find devices that are smooth, reliable, and suitable for office and personal use.",
},
{
  img: "/c.png",
  title: "Perfect Laptops for Office Use",
  desc: "From small businesses to offices, PC Care provides laptops that handle daily tasks like emails, software, and meetings with ease.",
},
{
  img: "/f.png",
  title: "Top Laptop Brands Available",
  desc: "Choose from popular brands like HP, Dell, Lenovo, and Apple. PC Care gives you multiple options so you can pick what suits you best.",
},
{
  img: "/d.png",
  title: "Easy Buying & Support",
  desc: "Buying a laptop should be simple. PC Care makes the process easy and also provides support whenever you need help after purchase.",
}
];

export default function BlogSection11() {
  const trackRef = useRef(null);
  const positionRef = useRef(0);
  const rafRef = useRef(null);
  const [paused, setPaused] = useState(false);

  const loopItems = [...contents, ...contents];

  useEffect(() => {
    const speed = 1.04;

    const animate = () => {
      const track = trackRef.current;
      if (!track) {
        rafRef.current = requestAnimationFrame(animate);
        return;
      }

      if (!paused) {
        positionRef.current += speed;

        const halfWidth = track.scrollWidth
          ? track.scrollWidth / 2
          : 0;

        if (halfWidth && positionRef.current >= halfWidth) {
          positionRef.current = 0;
        }

        track.style.transform = `translateX(-${positionRef.current}px)`;
      }

      rafRef.current = requestAnimationFrame(animate);
    };

    rafRef.current = requestAnimationFrame(animate);

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [paused]);

  // Manual arrows
  const slideBy = (dir) => {
    const track = trackRef.current;
    if (!track || !track.firstChild) return;

    const cardWidth =
      track.firstChild.getBoundingClientRect().width || 0;

    let gap = 24;
    const innerCard = track.firstChild.firstChild;
    if (innerCard && typeof window !== "undefined") {
      const styles = window.getComputedStyle(innerCard);
      const mx =
        (parseFloat(styles.marginLeft) || 0) + (parseFloat(styles.marginRight) || 0);
      if (Number.isFinite(mx) && mx > 0) gap = mx;
    }

    const step = cardWidth + gap;

    let next =
      dir === "next"
        ? positionRef.current + step
        : positionRef.current - step;

    const halfWidth = track.scrollWidth
      ? track.scrollWidth / 2
      : 0;

    if (halfWidth && next >= halfWidth) next = 0;
    if (halfWidth && next < 0) next = Math.max(halfWidth - step, 0);

    positionRef.current = next;

    track.style.transition =
      "transform 700ms cubic-bezier(0.22,1,0.36,1)";
    track.style.transform = `translateX(-${next}px)`;

    setTimeout(() => {
      if (trackRef.current)
        trackRef.current.style.transition = "none";
    }, 700);
  };

  return (
    <section className="bg-[#fff] px-6 py-12 lg:pt-24">
      <div className="mb-16 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#351F72] tracking-tight">
          PC Care – Tech Updates
        </h2>
        {/* <p className="text-gray-500 max-w-xl mx-auto">
          Buy, repair, and upgrade laptops at PC Care Jabalpur — all under one roof.
        </p> */}
      </div>

      <div
        className="relative overflow-hidden"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div ref={trackRef} className="flex will-change-transform">
          {loopItems.map((item, i) => (
            <div
              key={i}
              className="w-full sm:w-1/2 lg:w-1/3 flex-shrink-0"
            >
              <ContentCard {...item} />
            </div>
          ))}
        </div>

        <div className="mt-8 flex justify-center gap-6">
          <button
            onClick={() => slideBy("prev")}
            className="bg-gray-100 rounded-full w-11 h-11 
                       flex items-center justify-center transition"
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>

          <button
            onClick={() => slideBy("next")}
            className="bg-gray-100 rounded-full w-11 h-11 
                       flex items-center justify-center transition"
          >
            <i className="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
